<template>
  <div
    class="fixed top-0 left-0 z-10 items-center w-full mobile-nav-container"
    style="filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.15)); background-color: #02031f;"
  >
    <TopBlock
      :drawer-open="$store.state.openTopNavDrawer"
      @drawerToggled="setDrawerVisibility(!$store.state.openTopNavDrawer)"
    />

    <transition
      enter-active-class="transition-transform duration-100 transform"
      leave-active-class="transition-transform duration-100 transform"
      enter-class="translate-x-full"
      enter-to-class="translate-x-0"
      leave-class="translate-x-0"
      leave-to-class="translate-x-full"
    >
      <MobileDrawer
        v-show="$store.state.openTopNavDrawer"
        @close="setDrawerVisibility(false)"
      />
    </transition>
  </div>
</template>

<script>
import TopBlock from './top-block';
import MobileDrawer from './drawer';
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';

export default {
  components: {
    TopBlock,
    MobileDrawer,
  },

  methods: {
    setDrawerVisibility(open = true) {
      this.$store.dispatch('setOpenTopNavDrawer', open);
      if (open) {
        eventTracker(analyticsEvents.myAccountArea.menuOpened, { menu: 'top right' });
      }
    },
  },
};
</script>

<style>
.mobile-nav-container {
  padding: 12px 16px;
}
.mobile-nav-container button {
  border: 0;
  color: inherit;
  background-color: transparent;
  font-family: "Artlist Sans";
}

.mobile-nav-container {
  z-index: 1000;
}
@screen sm {
  body.overflow-hidden .mobile-nav-container {
    z-index: auto;
  }
}
</style>
